import style from "./style.module.css";
import video from "../../../assets/video.svg";
import search from "../../../assets/search.svg";
import reload from "../../../assets/reload.svg";
import plus from "../../../assets/plus.svg";
import pdf from "../../../assets/pdf.svg";
import { Link } from "react-router-dom";
import { useContext } from "react";
import StoreContext from "../../../context/store";
import { getStudentPdf } from "../../../api/general";

const Bar = () => {
  const { setAddStudentClick, setStudentInputValue, studentInputValue } = useContext(StoreContext);

  const getStudentPdfMethod = async () => {
    const response = await getStudentPdf();
    if (response.error) {
      console.log("Öğrenci pdfi gelmedi");
      console.log(response.error, "response.erro");
    } else {
      console.log("Öğrenci pdfi geldi");
    }
  };

  return (
    <div className={style.container}>
      <div className={style.students}>
        <div className={style.studentstext}>Öğrenciler</div>
        <Link>
          <img alt="" className={style.studentsvideo} src={video}></img>
        </Link>
      </div>
      <div className={style.search}>
        <button className={style.searchicon}>
          <img alt="" src={search}></img>
        </button>
        <input
          className={style.searchinput}
          placeholder="Ara"
          onChange={(e) => {
            setStudentInputValue(e.target.value);
          }}
          value={studentInputValue}
        ></input>
      </div>
      <button
        onClick={() => {
          window.location.reload();
        }}
      >
        <img alt="" className={style.reload} src={reload}></img>
      </button>
      <div className={style.tabs}>
        <div className={style.tab}>
          <button
            className={style.tabicon}
            onClick={() => {
              setAddStudentClick(true);
            }}
          >
            <img alt="" src={plus}></img>
          </button>
          <div className={style.tabtext}>Yeni Öğrenci</div>
        </div>
        <div className={style.tab}>
          <button
            className={style.tabicon}
            onClick={() => {
           //   getStudentPdfMethod();
            }}
          >
            <img alt="" src={pdf}></img>
          </button>
          <div className={style.tabtext}>PDF Yazdır</div>
        </div>
      </div>
    </div>
  );
};

export default Bar;
